<template>
  <v-card class="data-wrapper-core" flat v-if="tables && leads.length">
    <h3>Mapping Übersicht</h3>
    <v-divider class="mt-4"></v-divider>
    <v-card-text>
      <v-table>
        <thead>
          <tr>
            <th><h4>Feldname</h4></th>
            <th><h4>Ausgewählte Fragen</h4></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredTableAndProfileConfig" :key="item.name">
            <td>{{ item.name }}</td>
            <td>
              <v-chip
                v-for="question in item.questions"
                :key="question"
                class="ma-1"
                :color="getChipColor(question)"
              >
                {{ question }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </v-table>

      <v-divider class="mb-6"></v-divider>

      <h3>Nicht verwendete Fragen</h3>
      <v-divider class="my-4"></v-divider>
      <v-chip
        v-for="question in unusedQuestions"
        :key="question"
        class="ma-1"
        :color="getChipColor(question)"
      >
        {{ question }}
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    tables: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("table", ["leads"]),

    // ✅ Extract all unique question titles from ALL leads and track sources
    leadQuestionsWithSources() {
      if (!this.leads || this.leads.length === 0) {
        console.log("⚠️ No leads available!");
        return {};
      }

      const questionSources = {};
      this.leads.forEach((lead) => {
        if (lead.funnelData?.profile && lead.source) {
          Object.values(lead.funnelData.profile).forEach((profileField) => {
            if (profileField.title) {
              if (!questionSources[profileField.title]) {
                questionSources[profileField.title] = new Set();
              }
              questionSources[profileField.title].add(lead.source);
            }
          });
        }
      });

      console.log("✅ Extracted Lead Questions with Sources:", questionSources);
      return questionSources;
    },

    // ✅ Extract all field names from table config
    tableFieldNames() {
      if (!this.tables || !this.tables.tableAndProfileConfig) {
        console.log("⚠️ Table config missing!");
        return [];
      }

      return this.tables.tableAndProfileConfig
        .filter((item) => item.visibleInProfile)
        .map((item) => ({
          name: item.name,
          questions: item.questions || [],
        }));
    },

    // ✅ Find questions that are mapped in the table config
    filteredTableAndProfileConfig() {
      return this.tableFieldNames.map((item) => ({
        ...item,
        questions: item.questions.filter((q) =>
          Object.keys(this.leadQuestionsWithSources).includes(q)
        ),
      }));
    },

    // ✅ Find questions that exist in leads but are NOT mapped in the table config
    unusedQuestions() {
      const usedQuestions = new Set(
        this.filteredTableAndProfileConfig.flatMap((item) => item.questions)
      );

      return Object.keys(this.leadQuestionsWithSources).filter(
        (q) => !usedQuestions.has(q)
      );
    },
  },
  methods: {
    // ✅ Define source colors
    getChipColor(question) {
      const questionSources = this.leadQuestionsWithSources[question] || [];
      if (questionSources.size === 0) return "grey"; // Default color if no source

      // Define source-based colors
      const sourceColors = {
        onepage: "#BA24D5",
        funnelcockpit: "#293056",
        heyflow: "#175CD3",
        meetovo: "#06AED4",
        perspective: "#FF4405",
        thrive: "#4CA30D",
        typeform: "#1D2939",
        custom: "#DD2590",
        metaleadads: "#0064e2",
        manual: "#6141DB",
        csvupload: "#6141DB",
        generic: "#6141DB",
      };

      // Pick the first source color (or default to grey if not found)
      const firstSource = Array.from(questionSources)[0];
      return sourceColors[firstSource] || "grey";
    },
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: bold;
  font-size: 1.2em;
}
.v-table {
    background-color: #f9fafb;
}
</style>

